import { addToCart } from '@/utils/addToCart';
import { saveUserConfig } from '@/utils/saveUserConfig';
import ObsidianApi from 'obsidian-api';

/**
 * When application run as an iframe, IFrameApi is a way to communicate
 * between application (which is in iframe) and integration
 * Usually iframe is the app developed by Wanadev, integration is developed by client or BO team.
 * Documentation https://wanadev.github.io/obsidian-api/index.html
 */
const IFrameApi = ObsidianApi.$extend({
    /**
     * Sample API method
     *
     * @method echo
     * @param {String} text Text to echo
     * @return {String} the given text
     */
    echo: (text: string): string => {
        '@api';

        return text;
    },
});

const iFrameApi = new IFrameApi();
iFrameApi.addApiMethod('userSave', (prestashopUserId: number, prestashopSessionToken: string) => {
    return saveUserConfig(prestashopUserId, prestashopSessionToken);
});

iFrameApi.addApiMethod('addToCart', (preDefinedUniqueId: string) => {
    return addToCart(preDefinedUniqueId);
});

// Hot plug of new API methods (allows components to dynamically extend the API)
// iFrameApi.addApiMethod('myMethod', () => {});

// Send an event to the integration
// iFrameApi.sendEvent('eventName', 'param1', 'param2');

export default iFrameApi;
